import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withFetchDataLoader from '../../../../common/hoc/withFetchDataLoader';
import Report from '../components/Report';

import {
  fetchBarberPayoutsReport,
  fetchBarberLastPayoutDate,
  fetchBarberPayoutsHistoryInitial,
  fetchBarberPayoutsHistoryMore,
} from '../../../../main/reports/actions';
import {
  getPayoutReportFromDate,
  getPayoutReportToDate,
  getPayoutReportLastPayout,
} from '../../../../main/reports/selectors';
import * as authSelectors from '../../../../auth/selectors';
import { getBarberPayoutReport, getBarberPayoutTipReport } from '../selectors';

const fetchData = withHandlers({
  fetchData: (props) => () =>
    Promise.all([
      props.fetchBarberPayoutsReport(props.barberId),
      props.fetchBarberPayoutsHistoryInitial(props.barberId, 10),
      props.fetchBarberLastPayoutDate(props.barberId),
    ]),
});

const mapStateToProps = (state) => ({
  barberId: authSelectors.getBarberUserId(state),
  fromDate: getPayoutReportFromDate(state),
  toDate: getPayoutReportToDate(state),
  report: getBarberPayoutReport(state),
  tipReport: getBarberPayoutTipReport(state),
  lastPayoutDate: getPayoutReportLastPayout(state),
});

const mapDispatchToProps = {
  fetchBarberPayoutsReport,
  fetchBarberPayoutsHistoryInitial,
  fetchBarberPayoutsHistoryMore,
  fetchBarberLastPayoutDate,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), fetchData, withFetchDataLoader)(Report);
